export default __webpack_public_path__ + "static/gaute-3ebf500c653525864d1b744f2b6742f6.jpg";